import { useAppRoute } from '@/hooks/useAppRoute'

function formatNow() {
  return new Intl.DateTimeFormat('en-IN', {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).format(new Date())
}

export function Topbar() {
  const { isAgencyDetailRoute, isAgenciesRoute } = useAppRoute()
  const sectionLabel = isAgencyDetailRoute
    ? 'Agency detail'
    : isAgenciesRoute
      ? 'Agencies'
      : 'Dashboard'

  return (
    <header className="sticky top-0 z-10 flex items-center justify-between gap-4 border-b-2 border-line bg-surface/75 px-7 py-4 backdrop-blur-md">
      <div className="flex items-center gap-2">
        <span className="font-mono text-[0.72rem] uppercase tracking-[0.12em] text-muted">
          / Superadmin
        </span>
        <span aria-hidden="true" className="text-muted-soft">
          /
        </span>
        <span className="text-[0.92rem] font-semibold">{sectionLabel}</span>
      </div>

      <div className="flex items-center gap-2">
        <button
          type="button"
          aria-label="Search"
          className="inline-flex min-w-44 items-center gap-3 rounded-full border border-line bg-surface px-3 py-1.5 text-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent"
        >
          <span>Search</span>
          <kbd className="ml-auto rounded-md border border-line bg-paper px-1.5 py-0.5 font-mono text-[0.68rem] text-muted-soft">
            ⌘K
          </kbd>
        </button>
        <time
          className="whitespace-nowrap text-[0.82rem] text-muted max-md:hidden"
          dateTime={new Date().toISOString()}
        >
          {formatNow()}
        </time>
      </div>
    </header>
  )
}
